import React from "react";
import { Card, Form, Row, Col, Image, Button } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const HeroSection = ({ data, onUpdate }) => {
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleSlideChange = (index, field, value) => {
    const updatedSlides = [...data.slides];
    updatedSlides[index] = { ...updatedSlides[index], [field]: value };
    handleChange("slides", updatedSlides);
  };

  const handleFileUpload = async (index, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleSlideChange(index, "image", res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const addSlide = () => {
    const newSlide = { title: "", subtitle: "", image: "" };
    handleChange("slides", [...data.slides, newSlide]);
  };

  const removeSlide = (index) => {
    const updatedSlides = data.slides.filter((_, i) => i !== index);
    handleChange("slides", updatedSlides);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Hero Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          {data.slides.map((slide, index) => (
            <div key={index} className="mb-4 p-3 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6>Slide {index + 1}</h6>
                {data.slides.length > 1 && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeSlide(index)}
                  >
                    Remove
                  </Button>
                )}
              </div>
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={slide.title}
                      onChange={(e) => handleSlideChange(index, "title", e.target.value)}
                      placeholder="Enter slide title"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Subtitle</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={slide.subtitle}
                      onChange={(e) => handleSlideChange(index, "subtitle", e.target.value)}
                      placeholder="Enter slide subtitle"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Image</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        e.target.files?.[0] && handleFileUpload(index, e.target.files[0])
                      }
                    />
                    {isUploading && (
                      <div className="text-muted small mt-1">
                        Uploading...
                      </div>
                    )}
                    {slide.image && (
                      <div className="mt-2">
                        <Image
                          src={slide.image}
                          alt="Preview"
                          thumbnail
                          style={{ maxWidth: "200px" }}
                        />
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}
          <Button variant="outline-primary" onClick={addSlide}>
            Add Slide
          </Button>
        </Card.Body>
      )}
    </Card>
  );
};

export default HeroSection;
